import { render, staticRenderFns } from "./jura.vue?vue&type=template&id=4f749cce&scoped=true"
import script from "./jura.vue?vue&type=script&lang=js"
export * from "./jura.vue?vue&type=script&lang=js"
import style0 from "./jura.vue?vue&type=style&index=0&id=4f749cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f749cce",
  null
  
)

export default component.exports